import { render, staticRenderFns } from "./OfferHeader.vue?vue&type=template&id=9683451c&name=offer-header&"
import script from "./OfferHeader.vue?vue&type=script&lang=js&"
export * from "./OfferHeader.vue?vue&type=script&lang=js&"
import style0 from "./OfferHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports